import { render, staticRenderFns } from "./CourseResourceCard.vue?vue&type=template&id=9a9d45bc&scoped=true"
import script from "./CourseResourceCard.vue?vue&type=script&lang=js"
export * from "./CourseResourceCard.vue?vue&type=script&lang=js"
import style0 from "./CourseResourceCard.vue?vue&type=style&index=0&id=9a9d45bc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a9d45bc",
  null
  
)

export default component.exports